import { useEffect } from "react";
import { useCodebaseStore } from "@/store/zustand/codebaseStore";
import { useCanvasId } from "@/utils/utils";
import { useSession } from "@clerk/clerk-react";
import axios from "axios";
import { useTypedSelector } from "@/store/store";

export const useTailwindClasses = () => {
  const canvasId = useCanvasId();
  const { session } = useSession();
  const { setTailwindClasses } = useCodebaseStore();

  const projectLoadingProgress: any = useTypedSelector(
    (state) => state.supabaseStore.projectLoadingProgress
  );

  useEffect(() => {
    const fetchTailwindClasses = async () => {
      if (!session || !canvasId) return;

      // Have to wait for the container to be launched so we can run the generation
      if (!projectLoadingProgress?.launched_container) {
        return;
      }

      try {
        const supabaseJWT = await session.getToken();
        const response = await axios.get(
          `${
            import.meta.env.VITE_BACKEND_BASE_URL
          }/canvases/${canvasId}/tailwind/classes`,
          {
            headers: {
              Authorization: `Bearer ${supabaseJWT}`,
            },
          }
        );

        setTailwindClasses(response.data);
      } catch (error) {
        console.error("Error fetching Tailwind classes:", error);
        setTailwindClasses([]);
      }
    };

    fetchTailwindClasses();
  }, [
    canvasId,
    setTailwindClasses,
    projectLoadingProgress?.launched_container,
  ]);
};
